
import { useState } from 'react';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { MoreHorizontal } from 'lucide-react';
import { User } from '@/types/user';
import { GeneratePasswordResetDialog } from './GeneratePasswordResetDialog';

interface UserActionsMenuProps {
  user: User;
  onEditUser: () => void;
  onChangeRole: () => void;
  onResendInvitation: () => void;
  onDeactivateUser: () => void;
  onDeleteUser: () => void;
}

export function UserActionsMenu({ 
  user, 
  onEditUser,
  onChangeRole,
  onResendInvitation,
  onDeactivateUser,
  onDeleteUser
}: UserActionsMenuProps) {
  const [passwordResetDialogOpen, setPasswordResetDialogOpen] = useState(false);

  const shouldShowResendInvitation = () => {
    // Only show resend invitation for users who haven't signed in yet
    return user.invitationStatus === 'pending';
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8">
            <MoreHorizontal className="h-4 w-4" />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onEditUser}>
            Edit user
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onChangeRole}>
            Change role
          </DropdownMenuItem>
          {shouldShowResendInvitation() && (
            <DropdownMenuItem onClick={onResendInvitation}>
              Resend invitation
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onClick={() => setPasswordResetDialogOpen(true)}>
            Generate Password Reset Link
          </DropdownMenuItem>
          <DropdownMenuItem 
            className={user.status === 'Active' ? "text-destructive" : ""}
            onClick={onDeactivateUser}
          >
            {user.status === 'Active' ? 'Deactivate' : 'Activate'}
          </DropdownMenuItem>
          <DropdownMenuItem 
            className="text-destructive"
            onClick={onDeleteUser}
          >
            Delete user
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <GeneratePasswordResetDialog
        open={passwordResetDialogOpen}
        onOpenChange={setPasswordResetDialogOpen}
        user={user}
      />
    </>
  );
}
